import {
  NAME_MAX_LENGTH,
  NAME_MIN_LENGTH,
  NAME_VALIDATION_MESSAGES,
  SHORT_DESCRIPTION_MAX_LENGTH,
  SHORT_DESCRIPTION_VALIDATION_MESSAGES,
} from '@azymmetric/shared/validation/validation.constants';
import { zCoercedOptional, zFilteredStringArray } from '@utils/zodv4.util';
import { z } from 'zod/v4';

export const categorySchema = z.object({
  description: zCoercedOptional(
    z.string().max(SHORT_DESCRIPTION_MAX_LENGTH, { message: SHORT_DESCRIPTION_VALIDATION_MESSAGES.max }).optional(),
  ),
  name: z
    .string()
    .min(NAME_MIN_LENGTH, { message: NAME_VALIDATION_MESSAGES.min })
    .max(NAME_MAX_LENGTH, { message: NAME_VALIDATION_MESSAGES.max }),
  parentCategoryId: zCoercedOptional(z.uuid({ message: 'Please select a valid parent category.' }).optional()),
  subcategories: zFilteredStringArray(z.array(z.uuid())),
});

export type CategorySchema = z.infer<typeof categorySchema>;
